// Action types for the ticket system

// Admin ticket actions
export const ADMIN_INBOX_FETCH_REQUEST = 'ADMIN_INBOX_FETCH_REQUEST';
export const ADMIN_INBOX_FETCH_SUCCESS = 'ADMIN_INBOX_FETCH_SUCCESS';
export const ADMIN_INBOX_FETCH_FAILURE = 'ADMIN_INBOX_FETCH_FAILURE';

export const ADMIN_INBOX_UPDATE_FILTERS = 'ADMIN_INBOX_UPDATE_FILTERS';

export const ADMIN_INBOX_TICKET_DETAIL_REQUEST = 'ADMIN_INBOX_TICKET_DETAIL_REQUEST';
export const ADMIN_INBOX_TICKET_DETAIL_SUCCESS = 'ADMIN_INBOX_TICKET_DETAIL_SUCCESS';
export const ADMIN_INBOX_TICKET_DETAIL_FAILURE = 'ADMIN_INBOX_TICKET_DETAIL_FAILURE';

export const ADMIN_INBOX_REPLY_REQUEST = 'ADMIN_INBOX_REPLY_REQUEST';
export const ADMIN_INBOX_REPLY_SUCCESS = 'ADMIN_INBOX_REPLY_SUCCESS';
export const ADMIN_INBOX_REPLY_FAILURE = 'ADMIN_INBOX_REPLY_FAILURE';

export const ADMIN_INBOX_UPDATE_STATUS_REQUEST = 'ADMIN_INBOX_UPDATE_STATUS_REQUEST';
export const ADMIN_INBOX_UPDATE_STATUS_SUCCESS = 'ADMIN_INBOX_UPDATE_STATUS_SUCCESS';
export const ADMIN_INBOX_UPDATE_STATUS_FAILURE = 'ADMIN_INBOX_UPDATE_STATUS_FAILURE';

export const ADMIN_INBOX_UPDATE_CATEGORY_REQUEST = 'ADMIN_INBOX_UPDATE_CATEGORY_REQUEST';
export const ADMIN_INBOX_UPDATE_CATEGORY_SUCCESS = 'ADMIN_INBOX_UPDATE_CATEGORY_SUCCESS';
export const ADMIN_INBOX_UPDATE_CATEGORY_FAILURE = 'ADMIN_INBOX_UPDATE_CATEGORY_FAILURE';

export const ADMIN_INBOX_UPDATE_NOTES_REQUEST = 'ADMIN_INBOX_UPDATE_NOTES_REQUEST';
export const ADMIN_INBOX_UPDATE_NOTES_SUCCESS = 'ADMIN_INBOX_UPDATE_NOTES_SUCCESS';
export const ADMIN_INBOX_UPDATE_NOTES_FAILURE = 'ADMIN_INBOX_UPDATE_NOTES_FAILURE';

export const ADMIN_INBOX_DELETE_TICKET_REQUEST = 'ADMIN_INBOX_DELETE_TICKET_REQUEST';
export const ADMIN_INBOX_DELETE_TICKET_SUCCESS = 'ADMIN_INBOX_DELETE_TICKET_SUCCESS';
export const ADMIN_INBOX_DELETE_TICKET_FAILURE = 'ADMIN_INBOX_DELETE_TICKET_FAILURE';

export const ADMIN_INBOX_CLEAR_SELECTED_TICKET = 'ADMIN_INBOX_CLEAR_SELECTED_TICKET';
export const ADMIN_INBOX_INITIALIZE = 'ADMIN_INBOX_INITIALIZE';

// User ticket actions
export const USER_TICKET_FETCH_REQUEST = 'USER_TICKET_FETCH_REQUEST';
export const USER_TICKET_FETCH_SUCCESS = 'USER_TICKET_FETCH_SUCCESS';
export const USER_TICKET_FETCH_FAILURE = 'USER_TICKET_FETCH_FAILURE';

export const USER_TICKET_DETAIL_REQUEST = 'USER_TICKET_DETAIL_REQUEST';
export const USER_TICKET_DETAIL_SUCCESS = 'USER_TICKET_DETAIL_SUCCESS';
export const USER_TICKET_DETAIL_FAILURE = 'USER_TICKET_DETAIL_FAILURE';

export const USER_TICKET_REPLY_REQUEST = 'USER_TICKET_REPLY_REQUEST';
export const USER_TICKET_REPLY_SUCCESS = 'USER_TICKET_REPLY_SUCCESS';
export const USER_TICKET_REPLY_FAILURE = 'USER_TICKET_REPLY_FAILURE';

export const USER_TICKET_SUBMIT_REQUEST = 'USER_TICKET_SUBMIT_REQUEST';
export const USER_TICKET_SUBMIT_SUCCESS = 'USER_TICKET_SUBMIT_SUCCESS';
export const USER_TICKET_SUBMIT_FAILURE = 'USER_TICKET_SUBMIT_FAILURE';

// User feedback actions
export const USER_FEEDBACK_SUBMIT_REQUEST = 'USER_FEEDBACK_SUBMIT_REQUEST';
export const USER_FEEDBACK_SUBMIT_SUCCESS = 'USER_FEEDBACK_SUBMIT_SUCCESS';
export const USER_FEEDBACK_SUBMIT_FAILURE = 'USER_FEEDBACK_SUBMIT_FAILURE';
